<template>
</template>

<script>
  const INTERVALO_FILA = 10 * 60 * 1000; // 10 minutos
  const INTERVALO_MENSAGEM = 2000; // 2 segundos

  export default {
    name: "FilaChatbot",
    props: ['empresa'],

    data() {
      return {
        loading: {},
        isLooping: false,
        filaTimeOut: null
      }
    },

    methods: {
      async loopFila() {
        if (this.isLooping) {
          console.log('⚠️ loopFila já está em execução, ignorando chamada duplicada.');
          return;
        }

        this.isLooping = true;
        console.log('🔁 Iniciando loopFila...');

        try {
          if (this.filaTimeOut) {
            clearTimeout(this.filaTimeOut);
          }

          if (!this.$socket.connected) {
            console.log('Socket desconectado. Aguardando reconexão...');
            this.filaTimeOut = setTimeout(() => this.loopFila(), 30000);
            return;
          }

          for (const session of this.wpp_session.filter((item, index, all) => all.findIndex(other => String(other.id_empresa) === String(item.id_empresa)) === index)) {
            await this.getFila(session);
          }

          // agenda o próximo ciclo
          this.filaTimeOut = setTimeout(() => this.loopFila(), INTERVALO_FILA);

        } catch (err) {
          console.error('Erro no loopFila:', err);

        } finally {
          this.isLooping = false;
        }
      },

      async getFila(session) {
        if (!session?.key || this.loading[session.id_empresa]) return;

        this.$set(this.loading, session.id_empresa, true);
        const sessions = this.wpp_session.filter(item => String(item.id_empresa) === String(session.id_empresa));
        const params = {
          status: 1,
          sessions: sessions.map(item => item.phone),
          bandeiras: [...new Set(sessions.flatMap(item => item.bandeiras || []))]
        };

        try {
          const { data } = await this.$http.get(`chatbot/fila/${session.key}`, { params });

          if (data?.length) {
            const pending = data.filter(msg => sessions.some(item => String(item.phone) === String(msg.session)));
            await this.setFila(session.key, pending.map(p => ({ status: 2, id_fila: p.id_fila })));

            for (const [index, msg] of pending.entries()) {
              const content = msg.content || {};
              const target = sessions.find(item => String(item.phone) === String(msg.session));

              if (content.to && Array.isArray(content.msg)) {

                if (index > 0) {
                  await new Promise(resolve => setTimeout(resolve, (index > 0) ? INTERVALO_MENSAGEM : 0));
                }

                console.log('dispararMensagens', content.msg);
                window.control.dispararMensagens({
                  to: content.to,
                  wpp: target.wpp,
                  mensagens: content.msg.map(m => ({ content: m }))
                });
              }
            }
          }

        } catch (err) {
          this.$swal(err.response?.data?.msg || 'Erro temporário');

        } finally {
          this.$set(this.loading, session.id_empresa, false);
        }
      },

      async setFila(token, dados) {
        try {
          const res = await this.$http.post(`chatbot/fila/${token}`, { mensagens: dados });
          if (!res.data.success) {
            throw new Error('Não foi possível reservar a fila de mensagens.');
          }
        } catch (err) {
          console.error('Erro ao atualizar fila', err);
          throw err;
        }
      }
    },

    computed: {
      wpp_session() {
        return this.$store.state.wpp_session
      }
    },

    beforeDestroy() {
      clearTimeout(this.filaTimeOut);
      this.loading = {};
    }
  }
</script>
